export const CDN_BASE = import.meta.env.VITE_CDN_URL ?? 'https://wedsy-oeeii.sevalla.storage';
